import copyToClipboard from "copy-to-clipboard";

import { t } from "@/i18n-js/instance";
import { useConversationActionsToast } from "@/react/components/CircleAi/Home/ConversationActions/useConversationActionsToast";

export const useCopyLinkToClipboard = () => {
  const toast = useConversationActionsToast();

  return (url: string) => {
    copyToClipboard(url);
    toast.success(t("ai_conversation.copy_link.success"));
  };
};
